import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TenancyContext } from '@core/tenancy';
import { TenantKey } from '@app/core/enums/tenant-key.enum';
import { MinortStartRoutesSegments } from '../shared/enums';
import { MinorRouteSegmentsEnum } from '@app/minor-estates/shared/enums';

@Injectable({ providedIn: 'root' })
export class MinorStartNavigationService {
  private readonly _tenancy = inject(TenancyContext);
  private readonly _router = inject(Router);

  public goToAccount() {
    this._router.navigate([
      this._tenancy.link(
        TenantKey.MINOR,
        MinorRouteSegmentsEnum.Start,
        MinortStartRoutesSegments.Account,
      ),
    ]);
  }

  public goToOutOfJurisdiction() {
    this._router.navigate([
      this._tenancy.link(
        TenantKey.MINOR,
        MinorRouteSegmentsEnum.Start,
        MinortStartRoutesSegments.OutOfJurisdiction,
      ),
    ]);
  }

  public goToResidencyConfirmation() {
    this._router.navigate([
      this._tenancy.link(
        TenantKey.MINOR,
        MinorRouteSegmentsEnum.Start,
        MinortStartRoutesSegments.ResidencyConfirmation,
      ),
    ]);
  }
}
